import { CreateElement } from 'vue'
import { Component } from 'vue-property-decorator'

import { HealthGoal } from '@src/data/goal'
import { HealthGoals } from '@src/routes/members/components/health-goals/health-goals'
import { HealthGoalsService } from '@src/service/health-goal'

export type HealthGoalResponse = { health_goal: HealthGoal }

@Component
export class ReadonlyHealthGoals extends HealthGoals {

  constructor () {
    super()
    this.isCurrentWeekGoal = false
  }

  renderGoalOptions (h: CreateElement) {
    return null
  }

  protected loadGoalHistory (date: string) {
    if (date !== 'Invalid date') {
      return new HealthGoalsService().getGoalHistory(this.$route.params.id, date, '')
        .then(goal => {
          this.$store.dispatch('setGoal', goal)
        })
        .catch(() => {
          this.$store.dispatch('setGoal', null)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
